import React from 'react'
import { useParams } from 'react-router-dom'
import AgentList from '../../components/agent/AgentList'
import AddAgent from '../../components/agent/AddAgent'
import AgentDetails from '../../components/agent/AgentDetails'

const Agent = () => {
    let { method } = useParams();

    return (
        <>
            {method == "add" && <AddAgent />}
            {method == "list" && <AgentList />}
            {method == "view" && <AgentDetails />}
        </>
    )
}

export default Agent
